import { render, staticRenderFns } from "./ServiceCard.vue?vue&type=template&id=504db844&scoped=true&"
import script from "./ServiceCard.vue?vue&type=script&lang=ts&"
export * from "./ServiceCard.vue?vue&type=script&lang=ts&"
import style0 from "./ServiceCard.vue?vue&type=style&index=0&id=504db844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504db844",
  null
  
)

export default component.exports